import React from "react";
import {useCurrentFrame, useVideoConfig, spring, interpolate} from "remotion";
import {
  GLASS_BG,
  GLASS_BORDER,
  CORRECT_GREEN,
  CORRECT_GREEN_BG,
  CORRECT_GREEN_BORDER,
  WRONG_OPACITY,
  REVEAL_FRAME,
  CLAMP,
  FONT_STACK,
} from "./constants";

type PillState = "default" | "correct" | "wrong";

export const OptionPill: React.FC<{
  text: string;
  index: number;
  state: PillState;
  enterDelay: number;
}> = ({text, index, state, enterDelay}) => {
  const frame = useCurrentFrame();
  const {fps} = useVideoConfig();

  const enterProgress = spring({
    frame: frame - enterDelay,
    fps,
    config: {damping: 12, stiffness: 150, mass: 0.6},
  });

  const revealed = frame >= REVEAL_FRAME;
  const revealSnap = revealed
    ? interpolate(frame, [REVEAL_FRAME, REVEAL_FRAME + 4], [0, 1], CLAMP)
    : 0;

  const bgColor =
    state === "correct" && revealed ? CORRECT_GREEN_BG : GLASS_BG;
  const borderColor =
    state === "correct" && revealed ? CORRECT_GREEN_BORDER : GLASS_BORDER;

  const pillOpacity =
    state === "wrong" && revealed
      ? interpolate(revealSnap, [0, 1], [1, WRONG_OPACITY], CLAMP)
      : 1;

  const correctPulse =
    state === "correct" && revealed
      ? spring({
          frame: frame - REVEAL_FRAME,
          fps,
          config: {damping: 8, stiffness: 300, mass: 1.2},
        })
      : 0;
  const pulseScale =
    state === "correct"
      ? interpolate(correctPulse, [0, 0.5, 1], [1, 1.05, 1], CLAMP)
      : 1;

  const translateY = interpolate(enterProgress, [0, 1], [20, 0], CLAMP);
  const scale =
    interpolate(enterProgress, [0, 1], [0.8, 1], CLAMP) * pulseScale;

  const glowShadow =
    state === "correct" && revealed
      ? `0 0 20px ${CORRECT_GREEN}40, 0 0 40px ${CORRECT_GREEN}20`
      : "none";

  return (
    <div
      style={{
        opacity: enterProgress * pillOpacity,
        transform: `translateY(${translateY}px) scale(${scale})`,
        background: bgColor,
        border: `1px solid ${borderColor}`,
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        borderRadius: 999,
        padding: "14px 28px",
        alignSelf: "flex-start",
        fontSize: 18,
        fontWeight: 500,
        color: state === "correct" && revealed ? CORRECT_GREEN : "#ffffff",
        fontFamily: FONT_STACK,
        letterSpacing: 0.3,
        boxShadow: glowShadow,
      }}
    >
      {String.fromCharCode(65 + index)}) {text}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
